// extracted by mini-css-extract-plugin
module.exports = {"spot":"CasesSpot_spot__Ha7Eb","title":"CasesSpot_title__96hTX","description":"CasesSpot_description__rQMQf"};